import {Disclosure} from '@headlessui/react'

export default function ProductDisclosure({faq}: {faq: any}) {
  return (
    <div className="w-full pt-6">
      <div className="w-full  rounded-2xl bg-white">
        <Disclosure>
          {({open}) => (
            <>
              <Disclosure.Button className="flex bg-gray-300 w-full items-center justify-between rounded-lg bg-purple-100 px-4 py-4 text-left text-sm font-medium text-purple-900 hover:bg-purple-200 focus:outline-none focus-visible:ring focus-visible:ring-purple-500 focus-visible:ring-opacity-75">
                <span className="text-lg font-semibold text-primary">
                  {faq.heading}
                </span>

                <svg
                  className={`${
                    open ? 'rotate-180 transform' : ''
                  } h-6 w-6 text-primary-500`}
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="1.5"
                  stroke="currentColor">
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M19.5 8.25l-7.5 7.5-7.5-7.5"
                  />
                </svg>
              </Disclosure.Button>
              <Disclosure.Panel className="text-text-color leading-[2rem] px-4 py-6 text-[15px]">
                {faq.description}
              </Disclosure.Panel>
            </>
          )}
        </Disclosure>
      </div>
    </div>
  )
}
